<template>
  <date-range-picker
    ref="picker"
    :opens="'right'"
    :dateRange="{
      startDate: null,
      endDate: null,
    }"
    :append-to-body="true"
    :auto-apply="true"
    :localeData="{
      direction: 'ltr',
      format: 'dd/mm/yyyy',
      separator: ' a ',
      applyLabel: 'Aplicar',
      cancelLabel: 'Cancelar',
      daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      monthNames: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ],
      firstDay: 0,
    }"
    :ranges="false"
    @update="update"
  >
    <template v-slot:input="picker" style="min-width: 350px">
      Filtrando de {{ picker.startDate | date }} até {{ picker.endDate | date }}
    </template>
  </date-range-picker>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';

export default {
  components: { DateRangePicker },
  methods: {
    update(startDate_endDate) {
      const from = new Date(startDate_endDate.startDate).getTime() / 1000.0;
      const to = new Date(startDate_endDate.endDate).getTime() / 1000.0;
      this.$emit('filter_ranking', {
        from: from,
        to: to,
      });
    },
  },
  filters: {
    date(val) {
      console.log(val);
      return val ? moment(val).format('DD/MM/YYYY') : '';
    },
  },
};
</script>
